import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import HelpModal from './HelpModal';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [isHelpOpen, setIsHelpOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleLogout = async () => {
        await signOut(auth);
        navigate('/');
    };

    const navLinkClass = ({ isActive }) =>
        `px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive
            ? 'bg-sky-100 text-sky-700'
            : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
        }`;

    return (
        <>
            <nav className="bg-white shadow-sm border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16">
                        <div className="flex">
                            <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => navigate('/')}>
                                <span className="text-xl font-bold text-sky-700">PaddleMatch</span>
                            </div>
                            <div className="hidden sm:ml-6 sm:flex sm:space-x-8 items-center">
                                <NavLink to="/" className={navLinkClass}>
                                    Huts
                                </NavLink>

                                <NavLink to="/profile" className={navLinkClass}>
                                    Profile
                                </NavLink>
                            </div>
                        </div>

                        <div className="hidden sm:ml-6 sm:flex sm:items-center space-x-4">
                            <button
                                onClick={() => setIsHelpOpen(true)}
                                className="text-gray-500 hover:text-gray-700"
                                title="Help"
                            >
                                ❓
                            </button>
                            <div className="text-sm text-gray-500">
                                {user?.email}
                            </div>
                            <button
                                onClick={handleLogout}
                                className="text-sm text-red-600 hover:text-red-800 font-medium"
                            >
                                Logout
                            </button>
                        </div>

                        <div className="-mr-2 flex items-center sm:hidden">
                            <button
                                onClick={() => setIsMenuOpen(!isMenuOpen)}
                                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-sky-500"
                            >
                                <span className="sr-only">Open main menu</span>
                                {/* Hamburger icon */}
                                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Mobile menu */}
                {isMenuOpen && (
                    <div className="sm:hidden bg-white border-b border-gray-200">
                        <div className="pt-2 pb-3 space-y-1">
                            <NavLink
                                to="/"
                                className={({ isActive }) => `block px-3 py-2 text-base font-medium ${isActive ? 'bg-sky-50 text-sky-700 border-l-4 border-sky-500' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 border-l-4 border-transparent'}`}
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Huts
                            </NavLink>

                            <NavLink
                                to="/profile"
                                className={({ isActive }) => `block px-3 py-2 text-base font-medium ${isActive ? 'bg-sky-50 text-sky-700 border-l-4 border-sky-500' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 border-l-4 border-transparent'}`}
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Profile
                            </NavLink>
                            <button
                                onClick={() => { setIsHelpOpen(true); setIsMenuOpen(false); }}
                                className="block w-full text-left px-3 py-2 text-base font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900 border-l-4 border-transparent"
                            >
                                Help
                            </button>
                            <button
                                onClick={handleLogout}
                                className="block w-full text-left px-3 py-2 text-base font-medium text-red-600 hover:bg-gray-50 hover:text-red-900 border-l-4 border-transparent"
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                )}
            </nav>

            <HelpModal isOpen={isHelpOpen} onClose={() => setIsHelpOpen(false)} />
        </>
    );
};

export default Navbar;
